import { AxiosRequestConfig } from 'axios';
import { getLocationFromLocalStorage } from './location';

export function appendLocationToQueryParams(config: AxiosRequestConfig) {
  const location = getLocationFromLocalStorage();
  config.params = { ...config.params, ...location };
  return config;
}